import React from 'react';
import { Button } from 'ui-library';
import { convertDate } from 'pages/DocLibraryPage/utils/convertDate';
import { BundleDocumentType } from '../BundledDocuments.types';

export const getListOfBundledDocumentsColumns = ({ t }) => [
    {
        key: 'order_id',
        title: t('documentBundle.Table.position'),
    },
    {
        key: 'document_name',
        title: t('documentBundle.Table.documentName'),
    },
    {
        key: 'last_changed',
        title: t('documentBundle.Table.lastChanged'),
    },
    {
        key: 'view_details',
        title: t('documentBundle.Table.Action'),
    },
];

export const adaptListOfBundledDocuments = ({
    data, onViewDetails, t, securities, isLoading,
}) => data?.map((item) => {
    const security = securities?.find((sec) => sec.id === item.securityId);

    const viewDetailsData = {
        ...item,
        securityIsin: security?.isin,
        securityName: security?.name,
    };

    return {
        order_id: String(item?.orderIndex),
        document_name: `${item.name.replace(/\s*\[[a-z]{2}\]$/i, '').trim()} ${security?.name ? `| ${security?.name}` : ''}${item?.isJointAccount ? ` - ${t('ApplicationDetails.JointAccount.Title')}` : ''}`,
        last_changed: item.lastModifiedDate ? convertDate(item.lastModifiedDate) : '-',
        view_details: <div className="flex justify-center"><Button type="link" loading={isLoading === item?.id} disabled={item?.documentType === BundleDocumentType.Personal} onClick={() => onViewDetails({ item: viewDetailsData })}>{t('documentBundle.Table.viewDetails')}</Button></div>,
    };
});
